
import { Vue, Prop, Component } from "vue-property-decorator";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselect.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";

import CompanyScheduler from "@/views/scheduler/CompanyScheduler.vue"
import UiButton from "@/components/button/ui-button.vue";
import moment from "moment"
import S3Image from "@/components/common/s3-image.vue";

@Component({
    components: {
        ManagersMultiselect,
        FormGroup,
        UserLocationsMultiselect,
        RadioButtonGroup,
        ProfileCountrySelect,
        RegionInput,
        UserCityMultiselect,
        CompanyScheduler,
        UiButton,
        S3Image
    },
})
export default class ContractorResourceNotesModal extends Vue {
    @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;
    @Prop({ type: String, default: undefined }) readonly notes!: string;
    @Prop({ type: String, default: undefined }) readonly name!: string;
    @Prop({ type: String, default: undefined }) readonly surname!: string;
    @Prop({ type: String, default: undefined }) readonly created_at!: string;
    @Prop({ type: String, default: undefined }) readonly image?: string;
    @Prop({ type: Boolean, default: false }) readonly primary!: boolean;
    @Prop({ type: String, default: undefined }) readonly initial?: string;
    @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;
    @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;


    get avatarStyleClasses(): Record<string, boolean> {
        return {
            [this.avatarClasses]: Boolean(this.avatarClasses),
            ["border border-primary"]: this.highlightAvatar,
        };
    }


    closeModal(): void {
        this.$emit('close')
    }

    //@ts-ignore
    getFormattedDate(date): string {
        return moment(date).format("DD/MM/YY")
    }

    get defaultImageClasses(): string {
        return "inline-block rounded-full object-cover object-center";
    }

    get bgStyle(): object {
        return {
            background: this.primary ? "#1A7BEE" : hslColorFromName(this.initial || ""),
        };
    }

    get defaultInitialsClasses(): string {
        return "inline-flex h-6 w-6 rounded-full items-center justify-center";
    }

}
